import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

Font.register({
  family: 'FontAwesome',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/webfonts/fa-solid-900.ttf',
});

export const styles = StyleSheet.create({
  icon: {
    fontFamily: 'FontAwesome',
    fontSize: 16,
  },
  locationWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,

    marginTop: 10,
    marginBottom: 10,
    marginLeft: 53,
    marginRight: 53,
  },
  location: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 700,
  },

  description: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 'normal',
    lineHeight: 1.4,
    paddingLeft: 53,
    paddingRight: 53,
  },
  image: {
    width: '100%',
    height: 210,
  },
  imageRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
  },
  thumbnail: {
    width: '49%',
    height: 130,
    objectFit: 'cover',
    borderRadius: '8px',
  },
});
